<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <b-avatar
        size="40"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
        :src="currentUser && currentUser.profilePic ? currentUser.profilePic : ''"
      >
        <!-- <span>{{ avatarText(currentUser.name) }}</span> -->
      </b-avatar>
    </template>
    <!-- 
    <b-dropdown-item
      :to="{ name: 'pages-account-setting' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span>Settings</span>
    </b-dropdown-item> -->

    <!-- <b-dropdown-item
      :to="{ name: 'pages-faq' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="HelpCircleIcon"
        class="mr-50"
      />
      <span>FAQ</span>
    </b-dropdown-item> -->
    <b-dropdown-item link-class="py-1">
      <div class="d-flex align-items-center flex-wrap">
        <div class="d-flex flex-column">
          <h6 class="mb-0">
            {{ currentUser ? currentUser.name : 'User' }}
          </h6>
          <small class="text-muted">{{ currentUser ? currentUser.username : '' }}</small>
        </div>
      </div>
    </b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
      <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
      <span>Logout</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt';
import { initialAbility } from '@/libs/acl/config';
import userAuthMixin from '@/mixins/userAuth';
import { avatarText } from '@core/utils/filter';
import { BAvatar, BDropdownDivider, BDropdownItem, BNavItemDropdown } from 'bootstrap-vue';

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  mixins: [userAuthMixin],
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      avatarText,
    };
  },
  methods: {
    logout() {
      // Remove JWT data from localStorage
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);
      localStorage.removeItem('userData');

      // Reset ability
      this.$ability.update(initialAbility);

      // Use the logout method from our mixin to clear user data from Vuex
      this.$store.dispatch('user/logout');

      // Redirect to login page
      this.$router.push({ name: 'auth-login' });
    },
  },
};
</script>
